export default {
  props: {
    therm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      setpoint: this.therm.setpoint,
      alarmPoint: this.therm.alarmpoint,
      valid: false,
      setpointRules: [
        (v) => !!v || "Il setpoint è obbligatorio",
        (v) => (v >= 2.5 && v <= 35) || "Il setpoint deve essere tra 2.5°C e 35°C",
      ],
      errorMsg: "",
    };
  },
  watch: {
    setpoint() {
      this.validateSetpoint();
    },
  },
  methods: {
    open() {
      this.dialog = true;
      this.$nextTick(this.validateSetpoint);
    },
    validateSetpoint() {

      // Regole sul setpoint
      const ruleResults = this.setpointRules.map((r) => r(this.setpoint));
      const firstError = ruleResults.find((r) => r !== true);
      this.errorMsg = typeof firstError === "string" ? firstError : "";

      if (this.errorMsg) {
        this.valid = false;
        return;
      }

      // Se l'alarmPoint è troppo vicino / sopra la soglia, lo abbasso
      const maxAlarmPoint = this.setpoint - 2;
      if (this.alarmPoint > maxAlarmPoint) {
        this.alarmPoint = maxAlarmPoint;
      }

      // Ora valido la relazione tra setpoint e alarmPoint
      this.validateAlarmPoint();
    },

    validateAlarmPoint() {
      const maxAlarmPoint = this.setpoint - 2;

      if (this.alarmPoint > maxAlarmPoint) {
        // alarmPoint non è almeno 2°C sotto il setpoint
        this.errorMsg =
          "Il punto di allarme deve essere almeno 2°C sotto il setpoint";
        this.valid = false;
      } else {
        this.errorMsg = "";
        this.valid = true;
      }
    },
    submitSetpoint() {
      this.validateSetpoint();
      if (this.valid) {
        this.loading = true;
        this.$store
          .dispatch("set_therm_setpoint", {
            sid: this.therm.sid,
            setpoint: this.setpoint,
            alarmpoint: this.alarmPoint,
          })
          .then(() => {
            this.dialog = false;
          })
          .catch((err) => {
            console.error("Errore durante l'aggiornamento del setpoint:", err);
            this.errorMsg = "Errore durante l'aggiornamento del setpoint.";
          })
          .finally(() => {
            this.loading = false;
          });

        this.dialog = false;
        // Ad esempio: this.$emit('setpoint-changed', this.setpoint)
      }
    },
  },
};
